import React from 'react'
import { useActions, useValues } from 'kea'
import PropTypes from 'prop-types'

import SharedSearchbox from '~/scenes/shared/searchbox'
import centerZoomFromLocations from 'lib/utils/geo/center-zoom-from-locations'

import sceneLogic from '~/scenes/search/logic'
import mapLogic from '~/scenes/search/search-page/map/logic'

import './styles.scss'

export const MAX_ZOOM_FOR_SEARCH = 13

function Searchbox (props) {
  const { updateFilter, geolocate } = useActions(sceneLogic)
  const { updateMapCenterZoom } = useActions(mapLogic)
  const { filter, categorySuggestions } = useValues(sceneLogic)

  const { withMagnifyingGlass, searchCities, id } = props
  const { query } = filter

  const performCategorySearch = (query, data) => {
    updateFilter({
      query: query,
      query_slug: data ? data.slug : '',
      page: 1,
      category_tags: '',
      zoom_out_if_needed: true
    })
  }

  const performCitySearch = (query, data) => {
    const mapDiv = window.document.getElementById('search-page-main-pigeon-map')
    const width = mapDiv ? mapDiv.clientWidth : filter.width
    const height = mapDiv ? mapDiv.clientHeight : filter.height

    // result from autocomplete
    if (data && data.value && window.google) {
      const geocoder = new window.google.maps.Geocoder()
      geocoder.geocode({ placeId: data.value }, (results, status) => {
        if (status === window.google.maps.GeocoderStatus.OK && results && results[0]) {
          const place = results[0]

          if (place.geometry.viewport) {
            const viewport = place.geometry.viewport

            const ne = viewport.getNorthEast()
            const sw = viewport.getSouthWest()

            const nw = { lat: ne.lat(), lng: sw.lng() }
            const se = { lat: sw.lat(), lng: ne.lng() }
            const { center, zoom } = centerZoomFromLocations(
              [
                { latitude: nw.lat, longitude: nw.lng },
                { latitude: se.lat, longitude: se.lng },
                { latitude: place.geometry.location.lat(), longitude: place.geometry.location.lng() }
              ],
              width,
              height,
              0
            )

            updateMapCenterZoom(center, zoom)
            updateFilter({
              location: query,
              center,
              zoom,
              page: 1,
              width,
              height,
              zoom_out_if_needed: true
            })
          } else {
            const center = place.geometry.location

            updateMapCenterZoom([center.lat(), center.lng()], MAX_ZOOM_FOR_SEARCH)
            updateFilter({
              location: query,
              center: [center.lat(), center.lng()],
              zoom: MAX_ZOOM_FOR_SEARCH,
              page: 1,
              width,
              height,
              zoom_out_if_needed: true
            })
          }
        }
      })

      // no autocomplete (google didn't load?)
    } else if (query) {
      updateFilter({
        location: query,
        page: 1,
        width,
        height,
        coords_from_location: true,
        zoom_out_if_needed: true
      })
    }
  }

  const performLocate = () => {
    geolocate()
  }

  return searchCities ? (
    <SharedSearchbox
      withButton
      clearOnFocus
      withMagnifyingGlass={withMagnifyingGlass}
      searchCities
      categorySuggestions={[]}
      performSearch={performCitySearch}
      performLocate={performLocate}
      defaultValue=''
      dataAttr={(id || 'location-search') + '-search-box'}
      id={id || 'location-search'}
      className='apprentus-search-box'
    />
  ) : (
    <SharedSearchbox
      withButton
      clearOnFocus
      withMagnifyingGlass={withMagnifyingGlass}
      categorySuggestions={categorySuggestions}
      performSearch={performCategorySearch}
      defaultValue={query}
      dataAttr={(id || 'category-search') + '-search-box'}
      id={id || 'category-search'}
      className='apprentus-search-box'
    />
  )
}

Searchbox.propTypes = {
  withMagnifyingGlass: PropTypes.bool,
  searchCities: PropTypes.bool,
  id: PropTypes.string
}

export default React.memo(Searchbox)
